export enum ProductsEnum {
  INDIVIDUAL = 'individual',
  BUSINESS = 'business',
  AGRO = 'agro',
  INVEST = 'invest',
  SELECT = 'select',
}
